// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".status-indicator{--status-indicator-dimension:10px;background:#2dd158;border-radius:50%;height:var(--status-indicator-dimension);width:var(--status-indicator-dimension)}.status-indicator--small{--status-indicator-dimension:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
